import { ArrowUpRight } from "lucide-react";
import { useT } from "@/i18n/LanguageProvider";

export const DeveloperNote = ({ company }) => {
    const t = useT();
    return (
        <section className="bg-ink text-white py-24 sm:py-32" data-testid="developer-note">
            <div className="container-page">
                <div className="grid lg:grid-cols-12 gap-10 items-center">
                    <div className="lg:col-span-8">
                        <span className="overline text-clay-300">{t({ de: "Wir bauen weiter", en: "We keep building" })}</span>
                        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight mt-4 text-balance">
                            {t({ de: <>Wir suchen weitere Abriss- &amp;</>, en: "We are looking for more demolition &" })}
                            <span className="italic text-clay-300"> {t({ de: "Leerstands-Grundstücke.", en: "vacant-property plots." })}</span>
                        </h2>
                        <p className="font-body text-base sm:text-lg text-white/75 leading-relaxed mt-8 max-w-2xl">
                            {t({
                                de: "Sie besitzen ein Grundstück in Wiesbaden oder Umgebung – mit Abriss­objekt, leerstehendem Bestand oder ungenutzter Reserve? Wir kaufen direkt vom Eigentümer, schnell und unkompliziert. Auch Erbengemeinschaften und schwierige Lagen werden geprüft.",
                                en: "Do you own a plot in Wiesbaden or the surrounding area – with a demolition object, vacant stock or unused reserve? We purchase directly from the owner, quickly and unbureaucratically. Inheritance communities and difficult locations are also reviewed.",
                            })}
                        </p>
                    </div>

                    <div className="lg:col-span-4">
                        <a
                            href={`mailto:${company?.email || "info@g21-wiesbaden.de"}?subject=Grundst%C3%BCcksangebot`}
                            className="group block p-8 bg-white/5 border border-white/15 hover:bg-clay-300 hover:text-ink transition-all"
                            data-testid="land-offer-cta"
                        >
                            <div className="flex items-start justify-between mb-6">
                                <span className="overline text-clay-300 group-hover:text-ink/70">
                                    {t({ de: "Grundstück anbieten", en: "Offer land" })}
                                </span>
                                <ArrowUpRight size={22} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                            </div>
                            <div className="font-heading text-xl">
                                {company?.email || "info@g21-wiesbaden.de"}
                            </div>
                            <div className="font-body text-sm mt-1 opacity-70">
                                {t({ de: "Vertraulich · unverbindlich", en: "Confidential · non-binding" })}
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};
